import React, { useState } from "react";
import emailjs from "emailjs-com";

function Quote() {
  const [sendMessage, setSendMessage] = useState("Send!");
  const [disabled, setDisabled] = useState(false);
  /*
  function saveNameInStorage() {
    var name = document.getElementById("name").value;
    localStorage.setItem("name", name);
  }

  function saveEmailInStorage() {
    var email = document.getElementById("email").value;
    localStorage.setItem("email", email);
  }

  function saveBodyInStorage() {
    var body = document.getElementById("body").value;
    localStorage.setItem("body", body);
    console.log("in");
  }

  function saveBudgetInStorage() {
    var budget = document.getElementById("budget").value;
    localStorage.setItem("budget", budget);
  }
  */

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_m5127ve",
        "template_gvlpggf",
        e.target,
        "user_7JQPYuloqPkyNt2lj3kWV"
      )
      .then(
        (result) => {
          //console.log(result.text);
          e.target.reset();

          localStorage.setItem("name", "");
          localStorage.setItem("email", "");
          localStorage.setItem("body", "");
          localStorage.setItem("budget", "");

          setDisabled(true);
          setSendMessage("Sent");

          setTimeout(() => {
            setSendMessage("Send!");
            setDisabled(false);
          }, 4000);
        },
        (error) => {
          //console.log(error.text);
          setSendMessage("Error");

          setTimeout(() => {
            setSendMessage("Send!");
          }, 5000);
        }
      );
  };

  return (
    <div id="contact" className="contact-container">
      <h1 className="about-us-right-title">
        CONTACT
        <span style={{ color: "#4cb88f" }}>.</span>
      </h1>
      <div className="contact-container-inputs">
        <form onSubmit={sendEmail}>
          <input
            id="name"
            //onInput={saveNameInStorage}
            required
            type="text"
            name="name"
            placeholder="Name"
            style={{ width: "50%" }}
          />

          <input
            id="email"
            //onInput={saveEmailInStorage}
            required
            type="text"
            name="email"
            placeholder="Email"
            style={{ width: "50%" }}
          />
          <input
            id="budget"
            // onInput={saveBudgetInStorage}
            required
            type="text"
            name="budget"
            placeholder="Budget"
            style={{ width: "50%" }}
          />

          <textarea
            id="body"
            // onInput={saveBodyInStorage}
            required
            type="text"
            name="body"
            placeholder="Body"
            style={{ width: "100%", height: "300px" }}
          />

          <div style={{ textAlign: "right" }}>
            <button disabled={disabled} type="submit">
              {" "}
              {sendMessage}{" "}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Quote;
